import React, { PureComponent } from 'react';

class HeroTextTwo extends PureComponent {
  render() {
    return (
       <span>Anyways, take a few minutes to complete our assessment to better understand if your girlfriend is a
      </span>
    );
  }
}

export default HeroTextTwo;
